






import { Component, Vue } from 'vue-property-decorator';
import { useAuth } from '@/oauth'; // Adjust path if needed
import { User } from '@auth0/auth0-spa-js';

@Component
export default class DapperCallback extends Vue {
  async mounted() {
    try {
      this.$nextTick(async () => {
          const auth = useAuth(this);

          // Let the plugin handle the callback logic
          console.log(`DapperCallback.vue: calling handleRedirectCallback()...`)
          await auth.handleRedirectCallback();
          console.log(`DapperCallback.vue: handleRedirectCallback() completed.`)

          // debugging
          console.log(`user:`)
          const user: User = await auth.getUser()
          console.dir(user, { depth: null })
          const accessToken: string = await auth.getTokenSilently()
          console.log(`accessToken: ${accessToken}`)

          // Redirect the user to where they should go after login
          // e.g., their profile, dashboard, or a saved intended route
          console.log(`DapperCallback.vue redirecting user to /`)
          this.$router.push('/'); // << CHANGE TO YOUR DESIRED POST-LOGIN ROUTE

      });
    } catch (e) {
      console.error('Error during callback handling:', e);
      // Redirect to an error page or login page
      this.$router.push('/dapper/auth/error'); // Redirect to your error route
    }
  }
}
